import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    routes: {
      getClientsList: '/users/accounts',
      validateSession: '/users/session/validate',
      getAccountTokenForTechUser: '/users/techSupport/companies',
      searchClientList: '/users/accounts/search',
      checkUserStatus: '/users/reset/password',
      userMfaSettings: '/users/mfa/settings',
      verifyPhoneNumber: '/users/otp',
      verifySignInCode: '/users/otp/verify',
      deviceDetection: '/sense/device-detection'
    },
    isMobile: false
  },
  getters: {
    isMobile: state => {
      return state.isMobile
    }
  },
  mutations: {
    setIsMobile (state, flag) {
      state.isMobile = flag
    }
  },
  actions: {
  },
  modules: {
  }
})
